import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedoAlt } from "@fortawesome/free-solid-svg-icons";
import { primaryColor1 } from "../../../../../../common/helpers/colors";

const ReAnnotationButton = ({ isSomatic, onClick }) => {
  if (__IS_COMPONENTS_PORTAL__ || isSomatic) return null;
  return (
    <FontAwesomeIcon
      style={{
        height: "15px",
        width: "27px",
        color: primaryColor1,
      }}
      className="tw-px-1 tw-cursor-pointer"
      data-tooltip-delay={500}
      data-tooltip="Re-annotate as Somatic"
      onClick={() => onClick()}
      icon={faRedoAlt}
    />
  );
};

ReAnnotationButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isSomatic: PropTypes.bool.isRequired,
};

export default ReAnnotationButton;
